export class OnPremiseDatail {
    tableposref: string;
}
